module.exports = __webpack_public_path__ + "static/img/编组@2x.4c505bd0.png";